import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  Popconfirm,
  Row,
  Skeleton,
} from "antd";
import React, { useEffect, useState } from "react";
import Dashboard from "../Layout/Dashboard";
import {
  createCategory,
  deleteCategory,
  getCategory,
  updateCategory,
} from "../../actions/categories";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const Category = ({ currentUser }) => {
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const [, forceUpdate] = useState({});
  const { id } = useParams();

  const category = useSelector((state) => state.categories);

  useEffect(() => {
    setLoading(true);
    setLoadingButton(false);
    if (id) {
      dispatch(getCategory(id));
    }
    forceUpdate({});
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const dispatch = useDispatch();
  const history = useNavigate();
  const [form] = Form.useForm();

  const onFinish = (value) => {
    if (id) {
      setLoadingButton(true);
      let formData = {
        ...value,
        user: currentUser?.id,
      };
      dispatch(updateCategory(id, formData, history, setLoadingButton));
    } else {
      setLoadingButton(true);
      let formData = {
        ...value,
        user: currentUser?.id,
        store: currentUser.store,
      };
      dispatch(createCategory(formData, history, setLoadingButton));
    }
  };

  const deleteCategoryFun = () => {
    dispatch(deleteCategory(id, history));
  };

  useEffect(() => {
    form.setFieldsValue({
      name: category?.name,
    });
  }, [category]);

  return (
    <Dashboard title={`${id ? "View" : "Add"} Category`}>
      <div className="p-4 shadow bg-white mt-2 mb-6 flex items-center justify-between">
        <Breadcrumb>
          <Breadcrumb.Item>
            <a href="/categories">Categories</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{`${id ? "View" : "Add"} Category`}</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <Form
        layout="vertical"
        onFinish={onFinish}
        requiredMark={false}
        form={form}
        autoComplete="off"
      >
        <div className="md:grid md:grid-cols-3 md:gap-6 mb-4">
          <div className="mt-5 md:mt-0 md:col-span-2 px-4 py-5 sm:p-6 bg-white shadow">
            <Skeleton loading={loading}>
              <Row gutter={24}>
                <Col span={24}>
                  <Form.Item
                    label="Name"
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Please input category name!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Skeleton>
          </div>
          <div className="md:col-span-1">
            <div className="bg-white shadow px-4 py-5 sm:p-6">
              <Skeleton loading={loading}>
                <Row gutter={16}>
                  <Col span={24}>
                    <div className="flex flex-wrap  justify-center gap-4 my-7">
                      <Button href="/products">Cancel</Button>
                      <Form.Item shouldUpdate style={{ marginBottom: 0 }}>
                        {() => (
                          <Button
                            type="primary"
                            htmlType="submit"
                            disabled={
                              !form.isFieldsTouched(true) ||
                              !!form
                                .getFieldsError()
                                .filter(({ errors }) => errors.length).length
                            }
                            loading={loadingButton}
                          >
                            {`${id ? "Update" : "Save"} Category`}
                          </Button>
                        )}
                      </Form.Item>
                      {id ? (
                        <Popconfirm
                          title="Are you sure to delete this category?"
                          onConfirm={deleteCategoryFun}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button danger type="primary">
                            Delete
                          </Button>
                        </Popconfirm>
                      ) : (
                        ""
                      )}
                    </div>
                  </Col>
                </Row>
              </Skeleton>
            </div>
          </div>
        </div>
      </Form>
    </Dashboard>
  );
};

export default Category;
